export const createNode = (config) => {
    const node = document.createElement(config.type);

    // add Classes
    if(config.class) {
        
        if(Array.isArray(config.class)) {
            config.class.forEach(clss => {
                node.classList.add(clss);
            });
        }else {
            node.classList.add(config.class);
        }
    }

    // add text content
    if(config.textContent) {
        node.textContent = config.textContent;
    }

    // add data attribute
    if(config.attribute) {
        for (const key in config.attribute) {
            
            // eslint-disable-next-line no-prototype-builtins
            if (config.attribute.hasOwnProperty(key)) {
                node.setAttribute(key,config.attribute[key]);
            }
        }
    }

    return node;
}